import {
  parseRangeToSerializable,
} from '@/helpers/date';
import { RangoSerializable } from '@/models/componentes/datePicker.model';
import { Ejecutivo } from '@/models/respuestas/ejecutivo.model';
import { Cliente } from '@/models/store/cliente.model';
import { subMonths } from 'date-fns';

//#region Modelos a utilizar en los diferentes filtros

type KeyCondicion = 'aprobado' | 'rechazado' | 'asignado' | 'noAsignado';
export interface CondicionFiltroEstadoCliente {
  nombre: string;
  condicion: KeyCondicion;
}

export interface SeccionFiltroEstadoCliente
  extends CondicionFiltroEstadoCliente {
  // Siendo condicion el filtro inicial y opciones los filtros adicionales
  opciones: CondicionFiltroEstadoCliente[];
}

export type FiltrosClientes = {
  cliente: string;
  ejecutivo: Ejecutivo['idEjecutivo'][];
  estado: SeccionFiltroEstadoCliente[];
  registro: RangoSerializable;
};

export type CargaUtilFiltrosClientes = {
  filtro: keyof FiltrosClientes;
  carga: FiltrosClientes[keyof FiltrosClientes];
};

//#endregion

//#region Estados iniciales filtros estado
export const condicionesFiltrosEstadoCliente: Record<
  KeyCondicion,
  (c: Cliente) => boolean
> = {
  aprobado: (c) => c.estado,
  rechazado: (c) => !c.estado,
  asignado: (c) => Boolean(c.idEjecutivo),
  noAsignado: (c) => !c.idEjecutivo,
};

export const filtrosAprobacionCliente: CondicionFiltroEstadoCliente[] = [
  {
    nombre: 'Aprobado',
    condicion: 'aprobado',
  },
  {
    nombre: 'Rechazado',
    condicion: 'rechazado',
  },
];

export const filtrosEstadoAsignacion: SeccionFiltroEstadoCliente[] = [
  {
    nombre: 'Asignado',
    condicion: 'asignado',
    opciones: filtrosAprobacionCliente,
  },
  {
    nombre: 'No asignado',
    condicion: 'noAsignado',
    opciones: filtrosAprobacionCliente,
  },
];
//#endregion

export const filtroRegistroClienteEstadoInicial = {
  from: subMonths(new Date(), 3),
  to: new Date(),
};

export const filtrosInicialesClientes: FiltrosClientes = {
  cliente: '',
  ejecutivo: [],
  estado: filtrosEstadoAsignacion,
  registro: parseRangeToSerializable(filtroRegistroClienteEstadoInicial),
};

export const infoClienteCoincide = (c: Cliente, query: string): boolean => {
  if (query.length === 0) return true;

  const busqueda = query.toLowerCase();

  if (c.rut.includes(busqueda) || c.cliente.toLowerCase().includes(busqueda))
    return true;

  return false;
};

export const infoEjecutivoCoincide = (
  c: Cliente,
  e: Ejecutivo['idEjecutivo'][]
) => {
  // Si no tiene un ejecutivo asignado no lo filtro
  return c.idEjecutivo ? e.includes(c.idEjecutivo) : true;
};

export const infoEstadoCoincide = (
  c: Cliente,
  filtros: SeccionFiltroEstadoCliente[]
) => {
  for (const f of filtros) {
    const condicionSeccion = condicionesFiltrosEstadoCliente[f.condicion];

    if (condicionSeccion(c)) {
      for (const o of f.opciones) {
        const condicionOpcion = condicionesFiltrosEstadoCliente[o.condicion];

        if (condicionOpcion(c)) return true;
      }
    }
  }

  return false;
};

export const aplicarFiltrosClientes = (
  clientes: Cliente[],
  filtros: FiltrosClientes
) => {
  return clientes.filter(
    (c) =>
      infoClienteCoincide(c, filtros.cliente) &&
      infoEjecutivoCoincide(c, filtros.ejecutivo) &&
      infoEstadoCoincide(c, filtros.estado)
  );
};
